/* Previ theme — lightweight vanilla interactions. No dependencies. */
(function () {
  'use strict';

  /* ---------- Mobile navigation ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var nav = document.getElementById('mobile-nav');
      if (nav) {
        var open = nav.hasAttribute('hidden');
        if (open) { nav.removeAttribute('hidden'); } else { nav.setAttribute('hidden', ''); }
        toggle.setAttribute('aria-expanded', String(open));
        document.body.style.overflow = open ? 'hidden' : '';
      }
    }
    if (e.target.closest('[data-nav-close]')) {
      var n = document.getElementById('mobile-nav');
      if (n) { n.setAttribute('hidden', ''); document.body.style.overflow = ''; }
    }
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('cart-drawer');

  function openDrawer() {
    if (!drawer) return;
    drawer.removeAttribute('hidden');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.setAttribute('hidden', ''); }, 250);
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCart(cart) {
    var countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.toggleAttribute('hidden', cart.item_count === 0);
    });

    var body = drawer && drawer.querySelector('[data-cart-body]');
    var footer = drawer && drawer.querySelector('[data-cart-footer]');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="text-body text-muted" style="text-align:center;padding:3rem 0;">Your cart is empty.</p>';
      if (footer) footer.setAttribute('hidden', '');
      return;
    }
    if (footer) footer.removeAttribute('hidden');

    body.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" width="72" height="72" style="border-radius:var(--radius-md);object-fit:cover;">'
        : '<div style="width:72px;height:72px;border-radius:var(--radius-md);background:var(--background-gray);"></div>';
      return (
        '<div class="cart-line" data-line-key="' + item.key + '">' +
          img +
          '<div style="flex:1;min-width:0;">' +
            '<a href="' + item.url + '" class="text-label-lg" style="display:block;color:var(--text-dark);">' + item.product_title + '</a>' +
            (item.variant_title ? '<span class="text-caption text-muted">' + item.variant_title + '</span>' : '') +
            '<div class="qty" style="margin-top:.5rem;">' +
              '<button type="button" data-qty-down aria-label="Decrease">&minus;</button>' +
              '<input type="text" value="' + item.quantity + '" data-qty-input inputmode="numeric" aria-label="Quantity">' +
              '<button type="button" data-qty-up aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<div style="text-align:right;">' +
            '<span class="text-label-lg">' + money(item.final_line_price) + '</span>' +
            '<button type="button" data-line-remove class="text-caption text-muted" style="display:block;background:none;border:0;margin-top:.5rem;text-decoration:underline;">Remove</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    var subtotal = drawer.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = money(cart.total_price);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); return cart; });
  }

  /* Add to cart (product form) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"], form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) { renderCart(cart); openDrawer(); })
      .catch(function () {})
      .finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = btn.dataset.label || 'Add to cart'; } });
  });

  /* Drawer interactions */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); fetchCart().then(renderCart).then(openDrawer); }
    if (e.target.closest('[data-cart-close]') || e.target.hasAttribute('data-cart-overlay')) { closeDrawer(); }

    var line = e.target.closest('.cart-line');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var input = line.querySelector('[data-qty-input]');

    if (e.target.closest('[data-line-remove]')) { changeLine(key, 0); }
    if (e.target.closest('[data-qty-up]'))   { changeLine(key, parseInt(input.value, 10) + 1); }
    if (e.target.closest('[data-qty-down]')) { changeLine(key, Math.max(0, parseInt(input.value, 10) - 1)); }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* Prime the count on load */
  document.addEventListener('DOMContentLoaded', function () { fetchCart().then(renderCart).catch(function () {}); });
})();
